module.exports = __webpack_public_path__ + "img/gift-health.79c62476.png";